import React, {useState} from 'react';
import DotMenu from '../DotMenu/DotMenu';
import DisconnectModal from '../DissconnectModal/DissconnectModal';
import * as Styled from './AddAccountStyles';
import TokenStatus from '../TokenStatus/TokenStatus';
import Box from '../../styled/Box';

interface AddAccountBlockProps {
  platformName: string;
  addNew?: boolean;
  item?: any;
  loginLink?: string | null;
  icon: string;
}

const AddAccountBlock = ({platformName, addNew, item, loginLink, icon}:AddAccountBlockProps) => {
  const [isShowModal, setModalShow] = useState(false);
  const [dotMenuVisible, setDotMenuVisible] = useState(false);

  const showDotMenu = () => {
    setDotMenuVisible(true);
  }

  const hideDotMenu = () => {
    setDotMenuVisible(false);
  }

  const menuOptions = [{
    label: 'Disconnect',
    labelType: 'error',
    action: () => setModalShow(true),
  }]

  const onClose = () => {
    setModalShow(false);
  }

  let displayName = item.email;
  if (platformName === 'slack') {
    displayName = item.team_name;
  }

  return (
    <Styled.Container className='HoverAccount' onMouseEnter={showDotMenu} onMouseLeave={hideDotMenu}>
      {
        !addNew ?
          <Styled.Container className='DoShadow'>
            <Styled.Container className='Wrapper'>
              <img src={icon} alt="Service icon" height="60" width="60" />
              <Box maxWidth={'100%'}>
                {(item.data_status === 'in-progress' || item.teams_data_status === 'in-progress') && (
                  <Styled.IndexingText>
                    Setting up your account...
                  </Styled.IndexingText>
                )}
                <Styled.NameContainer>
                  <Styled.AccountName>
                    {displayName}
                  </Styled.AccountName>
                  <TokenStatus status={item.token_status} item={item} />
                </Styled.NameContainer>
              </Box>
            </Styled.Container>
            <Styled.Container className='DotsToSee'>
              <DotMenu options={menuOptions} visible={dotMenuVisible} />
            </Styled.Container>
            <DisconnectModal
              service={item}
              isOpen={isShowModal}
              onClose={onClose}
            />
          </Styled.Container>
        :
          <Styled.Container className='Wrapper DoShadow'>
            <Styled.StyledLink href={loginLink || ''}>
              <Styled.StyledSpan>+</Styled.StyledSpan>
            </Styled.StyledLink>
          </Styled.Container>
      }
    </Styled.Container>
  );
}

export default AddAccountBlock;